import React from "react";
import "./Service_pages.scss";
import img from "./services/dental_trauma.png"; // Replace with your actual image path
import whyImg from "./services/1.JPG";
import { FaCheckCircle, FaClinicMedical, FaUserMd, FaHeart, FaShieldAlt, FaMicroscope,  FaClock, FaBolt, FaFirstAid, FaHandHoldingHeart, FaUtensils, FaIceCream, FaTint, FaArrowsAlt, FaTooth } from 'react-icons/fa';
import {  MdOutlineHealthAndSafety, MdEmergency, MdHealing, MdBloodtype, MdBrokenImage, MdOutlineWaterDrop, MdWarningAmber } from "react-icons/md";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const TraumaCare = () => {

    const traumaTypes = [
        {
            title: "Chipped or Cracked Teeth",
            icon: <MdHealing />,
            desc: "One of the most common injuries. Whether it's a minor enamel chip or a deep crack exposing inner layers, we restore functionality and prevent sensitivity using bonding or crowns.",
        },
        {
            title: "Knocked-Out Tooth (Avulsion)",
            icon: <MdEmergency />,
            desc: "A critical emergency where time is of the essence. If treated within 30-60 minutes, our specialists can often successfully reinsert and stabilize the natural tooth in its socket.",
        },
        {
            title: "Dislodged or Loose Teeth",
            icon: <MdOutlineHealthAndSafety />,
            desc: "Trauma can push a tooth out of its normal position. We provide immediate stabilization and dental treatment to save the tooth and allow surrounding tissues to heal.",
        },
        {
            title: "Broken Tooth Roots",
            icon: <FaMicroscope />,
            desc: "Root fractures below the gum line aren't always visible but cause severe pain and swelling. We use advanced diagnostics to identify and treat these hidden injuries.",
        },
    ];

    // const firstAidSteps = [
    //     {
    //         title: "Control Bleeding",
    //         description: "Apply gentle pressure with clean gauze to any bleeding areas in the mouth or gums.",
    //     },
    //     {
    //         title: "Save the Tooth",
    //         description: "If knocked out, hold it by the crown (top), avoid touching the root, and rinse gently with milk or saline.",
    //     },
    //     {
    //         title: "Keep it Moist",
    //         description: "Place the tooth in milk or saliva to keep the root cells alive while traveling to the clinic.",
    //     },
    //     {
    //         title: "Apply Cold Compress",
    //         description: "Apply a cold pack to the outside of the face to reduce immediate swelling and manage pain.",
    //     },
    //     {
    //         title: "Visit Immediately",
    //         description: "Speed is critical. Reach Kosmix Dental Clinic promptly for professional emergency care.",
    //     },
    // ];

    const benefits = [
        {
            category: "Urgency",
            benefit: "Prevents Infection",
            description: "Immediate cleaning and sealing of trauma sites stop bacteria from reaching the tooth pulp.",
        },
        {
            category: "Urgency",
            benefit: "Saves Natural Teeth",
            description: "Early intervention significantly increases the chances of saving damaged or knocked-out teeth.",
        },
        {
            category: "Function",
            benefit: "Reduces Pain & Swelling",
            description: "Professional emergency care provides rapid relief from severe post-accident discomfort.",
        },
        {
            category: "Function",
            benefit: "Restores Chewing Ability",
            description: "Stabilizing loose teeth ensures you can return to normal eating and speaking quickly.",
        },
        {
            category: "Oral Health",
            benefit: "Prevents Long-term Loss",
            description: "Addressing trauma early reduces the need for complex implants or bridges in the future.",
        },
        {
            category: "Oral Health",
            benefit: "Gum & Tissue Care",
            description: "Expert treatment of cuts and soft tissue injuries prevents permanent scarring and complications.",
        },
    ];

    const reasons = [
        {
            icon: <FaUserMd />,
            title: 'Experienced Trauma Specialists',
            description: 'Our dental team is highly skilled in handling stressful emergencies with speed and precision.'
        },
        {
            icon: <MdEmergency />,
            title: 'Emergency Priority Care',
            description: 'We prioritize urgent trauma cases to ensure patients are seen during the critical "Golden Hour".'
        },
        {
            icon: <FaMicroscope />,
            title: 'Modern Diagnostic Tech',
            description: 'Using high-resolution digital X-rays and CBCT scans for accurate diagnosis of hidden fractures.'
        },
        {
            icon: <FaHeart />,
            title: 'Pain-Free Procedures',
            description: 'We utilize advanced local anesthesia to ensure emergency treatments are comfortable and stress-free.'
        },
        {
            icon: <FaShieldAlt />,
            title: 'Personalized Treatment',
            description: 'Every accident is different. We create custom plans to restore your unique smile safely.'
        },
        {
            icon: <FaClinicMedical />,
            title: 'Hygienic Environment',
            description: 'Our clinic follows strict sterilization protocols to prevent infection during trauma repair.'
        }
    ];

    return (
        <>
            <div className="service1-section">


                {/* HERO SECTION */}
                <div className="hero">
                    <h1 className="service1-title-text" data-aos="fade-down" data-aos-delay="200" style={{ fontFamily: 'initial' }}>
                        Immediate Dental Trauma Care in HSR Layout
                    </h1>

                    <div className="hero-content">
                        <div className="hero-image" data-aos="zoom-in-right" data-aos-delay="200" data-aos-duration="800">
                            <img src={img} alt="Emergency Dental Trauma Care" />
                        </div>

                        <div className="hero-text" data-aos="zoom-in-left" data-aos-delay="200" data-aos-duration="800">
                            <p>
                                Dental injuries can occur suddenly due to accidents, sports injuries, or falls. When these situations happen, receiving prompt trauma care from experienced professionals is essential to prevent long-term complications and preserve your oral health.
                            </p>
                            <p>
                                At <strong>Kosmix Dental Clinic</strong> in HSR Layout, we provide advanced trauma care for patients experiencing emergencies such as broken teeth, knocked-out teeth, or gum injuries. Our team uses modern diagnostic technology to restore your oral health quickly and safely.
                            </p>
                            <p>
                                Immediate treatment plays a crucial role in saving teeth and minimizing further damage. We focus on <strong>pain-free emergency care</strong>, accurate diagnosis, and effective solutions during stressful situations.
                            </p>

                        </div>
                    </div>
                </div>

                {/* DEFINITION SECTION */}
                <div className="content" data-aos="fade-up" data-aos-delay="300" >
                    <SectionTitle title="What is Dental Trauma?" />
                    <div className="text_first" >
                        <p1>
                            Dental trauma refers to physical injuries affecting the teeth, gums, jawbone, or surrounding oral tissues. These range from minor cosmetic chips to severe fractures and tooth displacement. Common causes include road accidents, sports impacts, workplace injuries, or simply biting on hard objects. Without immediate care, trauma can lead to permanent nerve damage, infection, or total tooth loss.
                        </p1>
                    </div>
                </div>

                {/* SIGNS AND FIRST AID ENHANCED SECTION */}
                <div className="trauma-emergency-grid">
                    <motion.div 
                        className="emergency-alert-board"
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                    >
                        <div className="board-header">
                            <MdWarningAmber className="header-icon pulse" />
                            <div className="header-text">
                                <h3>Signs You Need Immediate Care</h3>
                                <p>Watch for these symptoms immediately following an impact:</p>
                            </div>
                        </div>
                        
                        <div className="alert-items">
                            {[
                                { icon: <FaBolt />, text: "Severe or throbbing tooth pain." },
                                { icon: <MdBloodtype />, text: "Bleeding from the gums, lips, or tongue." },
                                { icon: <MdBrokenImage />, text: "Visible cracks, chips, or fractures in the enamel." },
                                { icon: <FaArrowsAlt />, text: "A tooth that feels loose or out of its normal position." },
                                { icon: <FaClinicMedical />, text: "Swelling in the jaw or gum area." },
                                { icon: <FaUtensils />, text: "Difficulty biting down or chewing properly." },
                                { icon: <FaIceCream />, text: "Heightened sensitivity to hot or cold." }
                            ].map((item, i) => (
                                <motion.div 
                                    className="alert-item" 
                                    key={i}
                                    whileHover={{ x: 10 }}
                                    transition={{ type: "spring", stiffness: 300 }}
                                >
                                    <span className="item-icon">{item.icon}</span>
                                    <span className="item-text">{item.text}</span>
                                </motion.div>
                            ))}
                        </div>
                    </motion.div>

                    <motion.div 
                        className="first-aid-protocol"
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        viewport={{ once: true }}
                    >
                        <div className="board-header secondary">
                            <FaFirstAid className="header-icon rotate" />
                            <div className="header-text">
                                <h3>First Aid Checklist</h3>
                                <p>Steps to take before reaching our clinic to save your tooth:</p>
                            </div>
                        </div>

                        <div className="protocol-steps">
                            {[
                                { title: "Stay Calm", desc: "Assess the injury quickly and check for bleeding.", icon: <FaHandHoldingHeart /> },
                                { title: "Save the Tooth", desc: "Hold it by the crown (top), not the root.", icon: <FaTooth /> },
                                { title: "Rinse Gently", desc: "Use milk or saline if dirty; do not scrub the root.", icon: <MdOutlineWaterDrop /> },
                                { title: "Keep Moist", desc: "Place the tooth in a container of milk or saliva.", icon: <FaTint /> },
                                { title: "Control Bleeding", desc: "Apply gentle pressure with clean gauze.", icon: <FaFirstAid /> },
                                { title: "Apply Cold", desc: "Use a compress to reduce facial swelling.", icon: <FaIceCream /> }
                            ].map((step, i) => (
                                <div className="protocol-card" key={i}>
                                    <div className="step-number">{i + 1}</div>
                                    <div className="step-icon">{step.icon}</div>
                                    <div className="step-info">
                                        <h4>{step.title}</h4>
                                        <p>{step.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </motion.div>
                </div>

                {/* TREATMENTS GRID */}
                <section className="crown-types-section">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="Advanced Trauma Treatments We Provide" />
                        <p1 className="text_first">
                            Our experienced dental team offers a full spectrum of restorative and surgical care to manage dental accidents:
                        </p1>
                    </div>

                    <div className="crown-grid">
                        {traumaTypes.map((item, idx) => (
                            <div className="crown-card" key={idx} data-aos="zoom-in" data-aos-delay={idx * 200}>
                                <div className="icon">{item.icon}</div>
                                <h3>{item.title}</h3>
                                <p>{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </section>

                {/* PROCEDURAL PATHWAY - COMPACT & UNIQUE */}
                <section className="procedural-pathway">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="Our Step-by-Step Response Protocol" />
                        <p className="path-subtitle">Precise workflow for optimal emergency outcomes</p>
                    </div>

                    <div className="pathway-container">
                        <div className="pathway-line"></div>
                        {[
                            { step: "1", title: "Diagnosis", icon: "🩺", desc: "Digital X-rays to locate fractures." },
                            { step: "2", title: "Stabilization", icon: "💉", desc: "Pain relief and dental splinting." },
                            { step: "3", title: "Restoration", icon: "🛠️", desc: "Bonding or root reimplantation." },
                            { step: "4", title: "Nerve Care", icon: "🛡️", desc: "Emergency RCT if pulp is damaged." },
                            { step: "5", title: "Monitoring", icon: "✅", desc: "Follow-ups for correct healing." }
                        ].map((item, index) => (
                            <motion.div 
                                className={`pathway-node node-${index + 1}`} 
                                key={index}
                                initial={{ opacity: 0, y: index % 2 === 0 ? -20 : 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.1, duration: 0.5 }}
                                viewport={{ once: true }}
                            >
                                <div className="node-marker">
                                    <span className="node-icon">{item.icon}</span>
                                    <div className="node-badge">{item.step}</div>
                                </div>
                                <div className="node-content">
                                    <h3>{item.title}</h3>
                                    <p>{item.desc}</p>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* BENEFITS TABLE */}
                <section className="benefits-section" data-aos="fade-up">
                    <div className="benefits-wrapper">
                        <div className="content">
                            <h2 className="section-title">Importance of Immediate Trauma Treatment</h2>
                        </div>
                        <div className="table-responsive">
                            <table className="styled-table">
                                <thead>
                                    <tr>
                                        <th>Category</th>
                                        <th>Specific Benefit</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {benefits.map((item, index) => (
                                        <tr key={index}>
                                            <td className="category-cell">
                                                {index === 0 || item.category !== benefits[index - 1].category ? item.category : ""}
                                            </td>
                                            <td>{item.benefit}</td>
                                            <td>{item.description}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>

                {/* PREVENTION SECTION */}
                <section className="advantages-section">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="How to Prevent Dental Trauma" />
                        <p1 className="text_first">
                            While accidents happen, these precautions can significantly reduce your risk of injury:
                        </p1>
                    </div>

                    <div className="advantages-grid">
                        {[
                            { title: "Wear Mouthguards", description: "Use custom-fitted mouthguards during contact sports or high-risk physical activities." },
                            { title: "Avoid Hard Objects", description: "Never use your teeth to open bottles or chew on extremely hard items like ice or pens." },
                            { title: "Use Safety Equipment", description: "Wear helmets and protective gear during cycling or skating to protect the jaw area." },
                            { title: "Maintain Checkups", description: "Regular dental visits ensure your teeth are strong and less prone to fractures." },
                            { title: "Safe Play Areas", description: "Ensure children play in safe environments to minimize falls and slips." },
                        ].map((item, index) => (
                            <div key={index} className="advantage-card" data-aos="fade-up" data-aos-delay={index * 100}>
                                <FaCheckCircle className="advantage-icon" />
                                <div>
                                    <h3>{item.title}</h3>
                                    <p>{item.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* FAQ SECTION */}
                <section className="pricing-section" data-aos="fade-up">
                    <div className="pricing-content">
                        <div className="text-area">
                            <div className="content" data-aos="fade-up">
                                <SectionTitle title="Dental Trauma FAQs" />
                                <p><strong>How soon should I visit the dentist?</strong> Immediately. For knocked-out teeth, treatment within 30–60 minutes offers the best chance of survival.</p>
                                <p><strong>Is trauma treatment painful?</strong> Most procedures use local anesthesia, making the clinical experience comfortable and pain-free.</p>
                                <p><strong>Can a broken tooth be repaired?</strong> Yes. Depending on the severity, we use bonding, crowns, or other restorative techniques.</p>
                            </div>
                        </div>

                        <div className="price-cards">
                            <div className="price-card">
                                <div className="tag">Golden Hour</div>
                                <h3 className="price"><FaClock /> 60 Mins</h3>
                                <p className="desc">Critical time window for knocked-out teeth</p>
                                <ul className="details">
                                    <li>● High Success Rate</li>
                                    <li>● Re-implantation Possible</li>
                                    <li>● Save Natural Root</li>
                                </ul>
                            </div>

                            <div className="price-card premium">
                                <div className="tag premium-tag">Emergency Priority</div>
                                <h3 className="price">24/7 Triage</h3>
                                <p className="desc">We prioritize urgent accident cases</p>
                                <ul className="details">
                                    <li>● Same-day Treatment</li>
                                    <li>● Instant Pain Relief</li>
                                    <li>● Specialist Reconstructive Care</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                {/* WHY CHOOSE KOSMIX - ENHANCED 2-COLUMN DESIGN */}
                <section className="why-kosmix-enhanced">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="Why Choose Kosmix Dental Clinic for Trauma Care?" />
                        <p className="section-intro">Providing rapid, reliable, and compassionate trauma response in Bengaluru.</p>
                    </div>

                    <div className="enhanced-wrapper">
                        <div className="visual-side" data-aos="zoom-in-right">
                            <img src={whyImg} alt="Dental Trauma Care Excellence" className="feature-img" />
                            <div className="img-overlay-card">
                                <h3>24/7 Response</h3>
                                <p>Triage for emergencies</p>
                            </div>
                        </div>

                        <div className="features-side">
                            {reasons.map((reason, index) => (
                                <motion.div 
                                    className="feature-item" 
                                    key={index}
                                    initial={{ opacity: 0, x: 20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ delay: index * 0.1 }}
                                    viewport={{ once: true }}
                                >
                                    <div className="feature-icon-box">
                                        {reason.icon}
                                    </div>
                                    <div className="feature-text-box">
                                        <h4>{reason.title}</h4>
                                        <p>{reason.description}</p>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* CTA SECTION */}
                <section className="cta-section" data-aos='zoom-in'>
                    <div className="cta-content">
                        <h2>Dental Emergency? <span>Contact Us Now!</span></h2>
                        <p>If you experience a tooth injury, severe pain, or dental trauma, our expert team is ready to help restore your smile immediately.</p>
                        <div className="cta-buttons">
                            <Link to="/#appointment">
                                <button className="btn-primary">Book Emergency Appointment</button>
                            </Link>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

const SectionTitle = ({ title }) => (
    <h2 className="section-title">{title}</h2>
);

export default TraumaCare;